<template>
  <el-dialog
    title="用户信息"
    v-model="memberInfoDialogStatus"
    width="600px"
    @close="close"
    :append-to-body="true"
  >
    <div>
      <div class="userinfo_popup_member">
        <div class="member_left">
          <div class="pr mr10">
            <img
              class="userinfo_avatar"
              :class="{ userinfo_avatar_green: onlyMyLook }"
              :src="memberInfo.avatar"
              alt=""
            />
          </div>
          <div class="infos">
            <div class="flex ai_c">
              <div class="userinfo_nickname">{{ memberInfo.nickname }}</div>
            </div>
            <div class="identity">
              <img
                v-if="memberInfo.level.moneyLevel > 1"
                class="identity_img"
                :src="memberInfo.level.moneyLevelImage"
                alt=""
              />
              <img
                class="identity_img"
                :src="memberInfo.level.levelImage"
                alt=""
              />
            </div>
            <div class="expiration_time">
              到期时间：{{ memberInfo.level.levelExpirationTime }}
            </div>
          </div>
        </div>
        <div class="member_right">
          <div>
            客户经理：{{
              hasServiceName ? memberInfo.offerInfo.info.service_name : "--"
            }}
          </div>
          <div class="red">
            注册手机号归属：{{ memberInfo.register_mobile_info.province
            }}{{ memberInfo.register_mobile_info.city }}
          </div>
          <div class="red">
            注册ip：{{ memberInfo.joinip || "--" }}
            <template
              v-if="
                memberInfo.register_ip_info.city &&
                memberInfo.register_ip_info.province
              "
            >
              （{{ memberInfo.register_ip_info.province
              }}{{ memberInfo.register_ip_info.city }}）
            </template>
            <template v-else>（--）</template>
          </div>
          <div class="red">
            访问ip：{{ memberInfo.visit_ip || "--" }}（{{
              memberInfo.visit_ip_address || "--"
            }}）
          </div>
          <div class="red">
            是否新湖ip地址：{{ memberInfo.visit_ip_xinhu ? "是" : "否" }}
          </div>
        </div>
      </div>
      <div>
        <el-table
          :data="memberInfo.offerInfo.allAsset"
          border
          style="width: 100%"
        >
          <!-- width="110" -->
          <el-table-column prop="company_name" label="期货公司" />
          <!-- width="90" -->
          <el-table-column prop="name" label="实盘名称" />
          <!-- <el-table-column prop="asset" label="资产账号" width="120" /> -->
          <!-- width="120"  -->
          <el-table-column prop="last_money_end" label="末" />
          <!-- <el-table-column prop="add_fee" label="加收手续费" /> -->
        </el-table>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import request from "@/utils/request";
export default {
  data() {
    return {
      memberInfoDialogStatus: false,
      onlyMyLook: false,
      memberInfo: {
        level: {},
        offerInfo: {
          allAsset: [],
          info: {},
        },
        register_mobile_info: {},
        register_ip_info: {},
      },
    };
  },
  computed: {
    hasServiceName() {
      return "service_name" in this.memberInfo.offerInfo.info;
      // 或者使用 hasOwnProperty 方法: return this.memberInfo.offerInfo.info && this.memberInfo.offerInfo.info.hasOwnProperty('service_name');
    },
  },
  methods: {
    open(id, onlyMyLook = false) {
      this.onlyMyLook = !!onlyMyLook;
      this.showMemberInfo(id);
      this.memberInfoDialogStatus = true;
    },
    close() {
      this.memberInfoDialogStatus = false;
      this.onlyMyLook = false;
    },
    async showMemberInfo(id) {
      const res = await request.post("/teacher/customer/getUserInfo", {
        id,
      });
      this.memberInfo = res.data;
      this.memberInfoDialogStatus = true;
    },
  },
};
</script>

<style scoped>
.userinfo_popup_member {
  width: 100%;
  display: flex;
  box-sizing: border-box;
  padding: 20px 20px 17px 20px;
  background: linear-gradient(225deg, #e3eeff 0%, #f3f8ff 100%);
  justify-content: space-between;
}
.member_left {
  flex: 1;
}
.member_right {
  width: max-content;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.userinfo_popup_member .userinfo_avatar {
  width: 44px;
  height: 44px;
  object-fit: cover;
  flex-shrink: 0;
  display: block;
  border-radius: 50%;
  border: 1px solid #dedede;
  box-sizing: border-box;
}
.userinfo_popup_member .userinfo_avatar_green {
  border: 2px solid #6bb519;
}

.userinfo_popup_member .infos {
}

.userinfo_popup_member .infos .userinfo_nickname {
  font-weight: 400;
  font-size: 16px;
  color: #333333;
  word-break: break-all;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  overflow: hidden;
  -webkit-line-clamp: 1;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  max-width: 120px;
}

.userinfo_popup_member .infos .identity {
  margin-top: 4px;
  display: flex;
  align-items: center;
  column-gap: 8px;
}

.userinfo_popup_member .infos .identity_img {
  height: 29px;
  display: block;
}

.userinfo_popup_member .expiration_time {
  font-weight: 400;
  font-size: 12px;
  color: #999999;
  margin-top: 8px;
}
.red {
  color: red;
}
</style>
